const ZodiacWheel = ({ size = 400, className = '' }) => (
  <svg viewBox="0 0 400 400" width={size} height={size} className={className} style={{ opacity: 0.04 }}>
    <circle cx="200" cy="200" r="190" fill="none" stroke="#2B2017" strokeWidth="0.8" />
    <circle cx="200" cy="200" r="160" fill="none" stroke="#2B2017" strokeWidth="0.5" />
    <circle cx="200" cy="200" r="130" fill="none" stroke="#2B2017" strokeWidth="0.3" />
    {[...Array(12)].map((_, i) => {
      const angle = (i * 30 * Math.PI) / 180
      const x1 = 200 + 130 * Math.cos(angle)
      const y1 = 200 + 130 * Math.sin(angle)
      const x2 = 200 + 190 * Math.cos(angle)
      const y2 = 200 + 190 * Math.sin(angle)
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#2B2017" strokeWidth="0.4" />
    })}
    {[...Array(12)].map((_, i) => {
      const angle = ((i * 30 + 15) * Math.PI) / 180
      const x = 200 + 175 * Math.cos(angle)
      const y = 200 + 175 * Math.sin(angle)
      return <circle key={`d${i}`} cx={x} cy={y} r="1.5" fill="#2B2017" opacity="0.5" />
    })}
  </svg>
)

const Constellation = ({ className = '' }) => (
  <svg viewBox="0 0 300 250" width="300" height="250" className={className} style={{ opacity: 0.04 }}>
    <circle cx="40" cy="30" r="2" fill="#2B2017" />
    <circle cx="120" cy="60" r="1.5" fill="#2B2017" />
    <circle cx="180" cy="25" r="2" fill="#2B2017" />
    <circle cx="260" cy="80" r="1.5" fill="#2B2017" />
    <circle cx="90" cy="140" r="2" fill="#2B2017" />
    <circle cx="200" cy="160" r="1.5" fill="#2B2017" />
    <circle cx="150" cy="210" r="2" fill="#2B2017" />
    <circle cx="260" cy="200" r="1.5" fill="#2B2017" />
    <line x1="40" y1="30" x2="120" y2="60" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="120" y1="60" x2="180" y2="25" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="180" y1="25" x2="260" y2="80" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="120" y1="60" x2="90" y2="140" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="90" y1="140" x2="200" y2="160" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="200" y1="160" x2="150" y2="210" stroke="#2B2017" strokeWidth="0.4" />
    <line x1="200" y1="160" x2="260" y2="200" stroke="#2B2017" strokeWidth="0.4" />
  </svg>
)

const Astrolabe = ({ size = 350, className = '' }) => (
  <svg viewBox="0 0 350 350" width={size} height={size} className={className} style={{ opacity: 0.035 }}>
    <circle cx="175" cy="175" r="170" fill="none" stroke="#2B2017" strokeWidth="0.6" />
    <circle cx="175" cy="175" r="140" fill="none" stroke="#2B2017" strokeWidth="0.4" />
    <circle cx="175" cy="175" r="100" fill="none" stroke="#2B2017" strokeWidth="0.3" />
    <circle cx="175" cy="175" r="60" fill="none" stroke="#2B2017" strokeWidth="0.3" />
    <circle cx="175" cy="175" r="20" fill="none" stroke="#2B2017" strokeWidth="0.4" />
    {[...Array(24)].map((_, i) => {
      const angle = (i * 15 * Math.PI) / 180
      const x1 = 175 + 60 * Math.cos(angle)
      const y1 = 175 + 60 * Math.sin(angle)
      const x2 = 175 + 170 * Math.cos(angle)
      const y2 = 175 + 170 * Math.sin(angle)
      return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#2B2017" strokeWidth="0.2" />
    })}
    <ellipse cx="175" cy="175" rx="80" ry="40" fill="none" stroke="#2B2017" strokeWidth="0.3" transform="rotate(-20 175 175)" />
    <ellipse cx="175" cy="175" rx="80" ry="40" fill="none" stroke="#2B2017" strokeWidth="0.3" transform="rotate(40 175 175)" />
  </svg>
)

const OrbitSketch = ({ className = '' }) => (
  <svg viewBox="0 0 200 200" width="200" height="200" className={className} style={{ opacity: 0.04 }}>
    <ellipse cx="100" cy="100" rx="90" ry="35" fill="none" stroke="#2B2017" strokeWidth="0.4" transform="rotate(-15 100 100)" />
    <ellipse cx="100" cy="100" rx="90" ry="35" fill="none" stroke="#2B2017" strokeWidth="0.4" transform="rotate(25 100 100)" />
    <ellipse cx="100" cy="100" rx="90" ry="35" fill="none" stroke="#2B2017" strokeWidth="0.4" transform="rotate(65 100 100)" />
    <circle cx="100" cy="100" r="3" fill="#2B2017" opacity="0.3" />
    <circle cx="170" cy="85" r="2" fill="#2B2017" opacity="0.4" />
    <circle cx="55" cy="130" r="1.5" fill="#2B2017" opacity="0.3" />
  </svg>
)

export { ZodiacWheel, Constellation, Astrolabe, OrbitSketch }
